import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DaliService } from '@dali/tagger-ng8';
import { UUID } from 'angular2-uuid';
import { interval, Subject, Subscription } from 'rxjs';

import { HeaderOnboardingComponent } from './shared/components/header/header-onboarding.component';
import { CHANNEL } from './shared/constants/channel.constants';
import {
  StepBiocatchEnum,
  StepBiocatchEnumFirmlyApproved,
} from './shared/enums/biocatchContext.enum';
import { OpEnum } from './shared/enums/op.enum';
import { IHeader } from './shared/interfaces/header.interface';
import { ExternalResponse } from './shared/models/channel-communicator/external-response.model';
import { SpecialOfferModel } from './shared/models/specialOffer/special-offer.model';
import { AbreCuentasService } from './shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from './shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from './shared/services/communicator/channel-communicator/channel-communicator.service';
import { PlatformCommunicatorAuthService } from './shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { SSOInformation } from './shared/services/communicator/security/sso/sso-information.model';
import { SsoService } from './shared/services/communicator/security/sso/sso.service';
import { BioCatchService } from './shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from './shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from './shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from './shared/services/header/header.service';
import { LoadingService } from './shared/services/loading/loading.service';
import { NavigationService } from './shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from './shared/services/parameters/parameters.service';
import { RequestService } from './shared/services/request/request-onboarding.service';
import { TaggingService } from './shared/services/tagging/tagging.service';
import { PopupService } from './shared/services/popup/popup.service';
import { IPopupState } from './shared/interfaces/popup.interface';
import { ConfigurationService } from './shared/services/configuration/configuration.service';
import { filter, first, takeUntil, tap } from 'rxjs/operators';

declare function getObjectData(item: string): any;
declare function getCsidPortal(): any;
const deviceInfo = {
  device_id: '',
  os_version: '',
  brand: '',
  model: '',
};

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

/**
 * Clase inicial de la aplicación
 *
 * *Initial app class*
 *
 */
export class AppComponent implements OnInit, AfterContentInit {
  /**
   * Declaración de la variable DSBinitCheck como Boolean
   *
   * *Set DSBinitCheck variable as boolean*
   *
   * @access              private
   * @type                {boolean}
   */
  private DSBinitCheck: boolean;

  /**
   * Declaración de la variable DSBisSecureByRiskRules como Boolean
   *
   * *Set DSBisSecureByRiskRules variable as boolean*
   *
   * @access              private
   * @type                {boolean}
   */
  private DSBisSecureByRiskRules: boolean;

  /**
   * Declaración de la variable DSBisSecureCertificate como Boolean
   *
   * *Set DSBisSecureCertificate variable as boolean*
   *
   * @access              private
   * @type                {boolean}
   */
  private DSBisSecureCertificate: boolean;

  /**
   * Declaración de la variable dsbConnectionAttempts como number
   *
   * *Set dsbConnectionAttempts variable as number*
   *
   * @access              public
   * @type                {number}
   */
  dsbConnectionAttempts: number;

  /**
   * Declaración de la variable showLoading como falso
   *
   * *Set showLoading variable as false*
   *
   * @access              public
   * @type                {boolean}
   */
  showLoading = false;

  /**
   * Declaración de la variable loadingSubscription como Subscription
   *
   * *Set loadingSubscription variable as Subscription*
   *
   * @access              public
   * @type                {Subscription}
   */
  loadingSubscription: Subscription;

  /**
   * Declaración de la variable header como IHeader
   *
   * *Set header variable as IHeader*
   *
   * @access              public
   * @type                {string}
   */
  header: IHeader = {
    show: false,
  };

  /**
   * Declaración de la variable headerSubscription como Suscribtion
   *
   * *Set headerSubscription variable as Subscription*
   *
   * @access              public
   * @type                {Subscription}
   */
  headerSubscription: Subscription;

  /**
   * Declaración de la variable mainClass como string
   *
   * *Set mainClass variable as string*
   *
   * @access              public
   * @type                {string}
   */
  mainClass: string;

  /**
   * Declaración de la variable channelId como string
   *
   * *Set channelId variable as string*
   *
   * @access              public
   * @type                {string}
   */
  channelId: string;

  /**
   * Referencia hacia el componente header
   *
   * *Header component reference*
   *
   * @access              public
   * @type                {HeaderOnboardingComponent}
   */
  @ViewChild(HeaderOnboardingComponent, { static: false })
  headerComponent: HeaderOnboardingComponent;

  /**
   * variable that get the details if the feature is called of details
   */

  states = {
    isIos: false,
    isAndroid: false,
  };

  tagReady: boolean;

  transactionId: any;

  isPostLogin: boolean;

  isIpadPro = false;
  showPopup: boolean;

  private productPreselected: string;
  private _subscriber$ = new Subject<void>();

  /**
   * Summary      Constructor of the component.
   *
   * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
   * @param {NavigationService}           navigationService           Injectable navigationService angular router.
   * @param {BioCatchService}             bioCatchService             Injectable bioCatchService service.
   * @param {ChannelCommunicatorService}  channelCommunicatorService  Injectable channelCommunicatorService service.
   * @param {ParametersService}           parametersService           Injectable parametersService service.
   * @param {LoadingService}              loadingService              Injectable loadingService service.
   * @function setLoadingSubscribe
   * @function setHeaderSubscribe
   */
  constructor(
    public abreCuentasService: AbreCuentasService,
    public navigationService: NavigationService,
    public bioCatchService: BioCatchService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private parametersService: ParametersService,
    private loadingService: LoadingService,
    private headerService: HeaderService,
    private domSanitizer: DomSanitizer,
    private taggingService: TaggingService,
    private ssoService: SsoService,
    private authService: PlatformCommunicatorAuthService,
    private requestService: RequestService,
    private cipherService: CryptoVaultService,
    private cdRef: ChangeDetectorRef,
    private bitacoraService: BitacoraService,
    private firmlyApprovedService: FirmlyApprovedService,
    private popupService: PopupService,
    private configurationService: ConfigurationService,
  ) {
    this.channelId = '0';
    this.showPopup = false;
    this.DSBinitCheck = false;
    this.DSBisSecureByRiskRules = false;
    this.DSBisSecureCertificate = false;
    this.dsbConnectionAttempts = 0;
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)) {
      this.isIpadPro = true;
    }
    this.states.isIos =
      navigator.userAgent !== undefined &&
      (
        /(iPhone|iPod|iPad).*AppleWebKit(?!state.*Safari)/i.test(
          navigator.userAgent,
        )
        || this.isIpadPro
      );
    this.states.isAndroid =
      navigator.userAgent !== undefined && /android/i.test(navigator.userAgent);
    deviceInfo.os_version = this.getDeviceInfoOsVersion();
    this.abreCuentasService.setDeviceInfo(deviceInfo);
    this.transactionId = UUID.UUID();
    this.abreCuentasService.setTransactionId(this.transactionId);
    this.setLoadingSubscribe();
    this.setHeaderSubscribe();
  }

  /**
   * Establece el valor para deviceInfo.os_version
   *
   * get the value for deviceInfo.os_version
   */
  getDeviceInfoOsVersion() {
    return this.states.isIos === true ? 'iOS' : 'Android';
  }

  // ngAfterViewChecked() {
  //   this.setHeaderSubscribe();

  // }

  /**
   * Muestra el estado de carga genérico de la aplicación y valida el canal de comunicación una vez el componente es cargado
   *
   * *Shows app generic loading state and validates communication channel once the component is loaded*
   */
  async ngOnInit() {
    let isUserJemelii = this.abreCuentasService.getQueryParamByName('userJemelii', window.location.search);
    console.log('userJemelii', this.abreCuentasService.getQueryParamByName('userJemelii', window.location.search));
    if (isUserJemelii && isUserJemelii == 'true') {
      this.abreCuentasService.setUserJemelii(true);
    } else {
      this.abreCuentasService.setUserJemelii(false);
    }
    this.popupService.popupState.subscribe(async (resp: IPopupState) => {
      this.showPopup = resp.showPopup;
    },
      // tslint:disable-next-line
      (error) => {
        console.error('Error getting popup state:', error);
      });
    this.init();
  }

  async init() {
    await this.channelCommunicatorService.validateChannel();
    this.channelId = this.channelCommunicatorService.getChannelId();
    this.isPostLogin = this.abreCuentasService.getPostlogin();
    this.validateClientType();
    if (!this.isPostLogin) {
      const ssoParameters = this.parametersService.getParameter('security_sso');
      let ssoResponse = await this.ssoService.enableAPIGateway(
        ssoParameters.login.grant_type,
        ssoParameters.login.client_id,
        ssoParameters.login.client_secret,
      );
      if (ssoResponse) {
        await this.keyCipherExchange();
      }
    } else {
      await this.getObjectData('3');
    }
  }

  private validateClientType() {
    if (!this.isPostLogin
      && this.channelCommunicatorService.getChannelId() === CHANNEL.SUPERAPP.CODE) {
      this.abreCuentasService.setIsNewClient(true);
    } else {
      this.abreCuentasService.setIsNewClient(false);
    }
  }

  async getSettings() {
    await this.requestService.getSettingsConfig('onboarding-fe-settings').then(async data => {
      await this.parametersService.loadApplicationSettings(data);
    });
    await this.requestService.getSettingsConfig('onboarding-co.tagging.service').then(async data => {
      await this.abreCuentasService.setTaggeo(data.data);
    });
    await this.getDistrict();
  }

  /**
   * Realiza la negociación de las llaves para el servicio de cryptoVault
   *
   * Negotiates the keys for cryptoVault service
   */
  async keyCipherExchange() {
    console.warn('Entró en App.component por keyCipherExchange ------');
    if (this.transactionId) {
      await this.cipherService.keyExchange(this.transactionId);
      await this.cipherService.refreshKeyCrypto();
      await this.requestService
        .getSessionId()
        .then(async response => {
          this.authService.saveSessionId(response.body.session_id as string);
          await this.getSettings();
          await this.biocatchInit();
          if (this.abreCuentasService.getUserJemelii() && !this.isPostLogin) {
            await this.getObjectDataForJemelli('3');
          }
        })
        .catch(() => {
          this.navigationService.navigateToGeneralInformation('600');
        });
    }
  }

  private async biocatchInit() {
    const biocatchConfig =
      this.channelId === CHANNEL.SUPERAPP.CODE
        ? this.parametersService.getSetting(
          OpEnum.ABRE_CUENTAS_BIOCATCH_CONFIGS_APPUNICA,
        )
        : CHANNEL.PORTALALLIES.CODE
          ? this.parametersService.getSetting(OpEnum.ALLIES_BIOCATCH_CONFIG)
          : this.parametersService.getSetting(
            OpEnum.ABRE_CUENTAS_BIOCATCH_CONFIGS,
          );
    // this.abreCuentasService.setCSID(this.authService.getSessionId());
    if (this.channelId !== CHANNEL.SUPERAPP.CODE && !this.isPostLogin) {
      let csid;
      if (this.channelId === CHANNEL.PORTALALLIES.CODE) {
        csid = this.authService.getSessionId();
      } else {
        csid = getCsidPortal();
      }
      this.abreCuentasService.setCSID(csid);
    }
    this.abreCuentasService.setBioCatchConfig(biocatchConfig);
    const initialContext =
      !this.isPostLogin && this.channelId === CHANNEL.SUPERAPP.CODE
        ? StepBiocatchEnum.solicitud
        : this.isPostLogin && !this.firmlyApprovedService.isEmpty()
          ? StepBiocatchEnumFirmlyApproved.solicitud_aprobado_firme
          : StepBiocatchEnum.productos;
    await this.bioCatchService.init(
      initialContext,
      this.channelId,
      this.isPostLogin,
    );

    this.bioCatchService.getPpidIsReady().pipe(takeUntil(this._subscriber$)).subscribe(
      async (isReady: boolean) => {
        if (isReady) {
          await this.initApp();
          if (this.isPostLogin) {
            const bitacoraEvent = this.abreCuentasService.getCSID();
            this.bitacoraService.saveDataInBitacora(bitacoraEvent, true);
          }
        }
      },
    );
  }

  /**
   * Obtiene el token del nativo para los flujos de cliente existente
   *
   * Get native token to postlogin flow
   */
  async getObjectData(item: string) {
    let ssoInformation: SSOInformation;
    console.log('Iniciando GetObjectData');
    if (this.states.isAndroid) {
      const object = await getObjectData(item);
      ssoInformation = new SSOInformation(JSON.parse(object).token);
      this.abreCuentasService.setCSID(JSON.parse(object).csid);
      this.abreCuentasService.setIp(JSON.parse(object).address);
      this.authService.saveSSOInformation(ssoInformation);
      this.authService.saveSSOTokenForOTP(ssoInformation);
      /**
       * Cargue de los datos de la vitrina de Aprobados en Firme
       */
      const saveData = await getObjectData('4');
      if (saveData) {
        if (typeof saveData == 'string') {
          const saveDataJson = JSON.parse(saveData).saveData;
          await this.getOfferChannelApp(saveDataJson);
        } else {
          const saveDataJson = saveData.saveData;
          await this.getOfferChannelApp(saveDataJson);
        }
      }

      await this.keyCipherExchange();
    } else if (this.states.isIos === true) {
      await getObjectData(item)
        .then(async (resultIos: any) => {
          ssoInformation = new SSOInformation(resultIos.token);
          this.abreCuentasService.setCSID(resultIos.csid);
          this.abreCuentasService.setIp(resultIos.address);
          this.authService.saveSSOInformation(ssoInformation);
          this.authService.saveSSOTokenForOTP(ssoInformation);
          /**
           * Cargue de los datos de la vitrina de Aprobados en Firme
           */
          const saveData = await getObjectData('4');
          if (saveData) {
            if (typeof saveData == 'string') {
              const saveDataJson = JSON.parse(saveData).saveData;
              await this.getOfferChannelApp(saveDataJson);
            } else {
              const saveDataJson = saveData.saveData;
              await this.getOfferChannelApp(saveDataJson);
            }
          }

          await this.keyCipherExchange();
        })
        .catch((error: any) => {
          console.log('error en javascript...', error);
        });
    } else {
      this.abreCuentasService.setIsPortal(true);
      await this.channelCommunicatorService
        .getImpl()
        .getObjectDataPortal()
        .then(async (tokenResult: any) => {
          ssoInformation = new SSOInformation(tokenResult.data.token);
          this.authService.saveSSOInformation(ssoInformation);
          this.authService.saveSSOTokenForOTP(ssoInformation);
          const csid = getCsidPortal();
          const data = csid === null || csid === undefined ? 'null' : csid;
          this.abreCuentasService.setCSID(data);
          this.abreCuentasService.setIp(tokenResult.data.address);

          /**
           * Cargue de los datos de la vitrina de Aprobados en Firme
           */
          await this.channelCommunicatorService
            .getImpl()
            .getFirmlyApprovedPortal()
            .then(async (additionalData: any) => {
              if (additionalData.data) {
                console.warn('Entrando por FirmlyApproved: ', additionalData);
                await this.validateAdditionalData(additionalData.data);
              }
            });
          await this.keyCipherExchange();
        });
    }
  }

  async getObjectDataForJemelli(item: string) {
    let ssoInformation: SSOInformation;
    console.log('Iniciando GetObjectData FOR JEMELLI');
    if (this.states.isAndroid) {
      const object = await getObjectData(item);
      ssoInformation = new SSOInformation(JSON.parse(object).token);
      this.authService.saveSSOTokenForOTP(ssoInformation);
    } else if (this.states.isIos === true) {
      await getObjectData(item)
        .then(async (resultIos: any) => {
          console.log('RESPUESTA OBJECT DATA JEMELLI...', resultIos);
          ssoInformation = new SSOInformation(resultIos.token);
          this.authService.saveSSOTokenForOTP(ssoInformation);
        })
        .catch((error: any) => {
          console.log('error en javascript...', error);
        });
    } else {
      this.abreCuentasService.setIsPortal(true);
      await this.channelCommunicatorService
        .getImpl()
        .getObjectDataPortal()
        .then(async (tokenResult: any) => {
          ssoInformation = new SSOInformation(tokenResult.data.token);
          this.authService.saveSSOTokenForOTP(ssoInformation);
        });
    }
  }

  /**
   * Función que permite validar si los parámetros que recibe son
   * de Aprobados En Firme o son para inicializar el flujo.
   * @param {any} data - Parámetros a validar.
   */
  private async validateAdditionalData(data: any) {
    console.warn('Datos recibidos: ', data);
    if (data && data.offerType !== '') {
      if (data.id === undefined || data.id === 0) {
        console.warn('<<<<<<<<<<<<<<<< Entró por nuevo flujo CE >>>>>>>>>>>>>>>>>>>>>>>>');
        this.productPreselected = data.offerType;
      } else {
        console.warn('<<<<<<<<<<<<<<<< Entró por flujo FirmlyApproved >>>>>>>>>>>>>>>>>>>>>>>>');
        await this.setDataOffer_FirmlyApproved(data);
      }
    }
  }

  /**
   * Función que permite cargar el Id de la Oferta que llega desde
   * el chasis del canal de App (Android & IOs)
   * @param {any} firmlyApprovedResult - Objeto de la vitrina del Aprobado en Firme que llega desde canal con la siguiente estructura:
   * {
   *  offerId - Id de la oferta publicada en la vitrina
   *  offerType - Tipo de la oferta publicada en la vitrina
   * }
   */
  async getOfferChannelApp(firmlyApprovedResult: any) {
    console.warn('Entrando por FirmlyApproved: ', firmlyApprovedResult);
    if (firmlyApprovedResult && firmlyApprovedResult !== '') {
      const data = JSON.parse(firmlyApprovedResult);
      this.validateAdditionalData(data);
    }
  }

  /**
   * Función que permite guardar los datos de la Oferta del Aprobado En Firme que viene desde Portal
   * @param {any} firmlyApprovedPortal - Datos recibidos desde caada Canal del Aprobado En Firme
   */
  async setDataOffer_FirmlyApproved(firmlyApprovedPortal: any) {
    let dataOffer: SpecialOfferModel = {
      offerId: firmlyApprovedPortal.id,
      offerType: firmlyApprovedPortal.offerType,
    };
    this.firmlyApprovedService.setOffer_Channel(dataOffer);
    await this.firmlyApprovedService.getProductsOffer();
  }

  /**
   * Define la clase principal de la aplicación una vez el contenido es cargado
   *
   * *Sets main class for the application once the content is loaded*
   *
   */
  ngAfterContentInit(): void {
    this.setMainClass();
  }

  // /**
  //  * Ejecuta la función initApp una vez la vista es cargado
  //  *
  //  * *Runs initApp function once the view is loaded*
  //  *
  //  */
  // async ngAfterViewInit() {
  //   // await this.initApp();
  //   // console.log('ngaferview')
  // }

  /**
   * Deshace las subscripcione del estado de carga y header una vez el componente se detruye
   *
   * *Unsubscribtion of loading state and header componente once the component is destroyed*
   */
  // tslint:disable-next-line
  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.headerSubscription.unsubscribe();
  }

  /* istanbul ignore next */
  /**
   * Inicializa las configuraciones necesarias para la aplicación
   * *Set up mandatory configuration of the app*
   *
   */
  async initApp() {
    this.abreCuentasService.setAbreCuentasConfigs(
      this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0],
    );
    try {
      await this.taggingService.initAnalytics();
      this.abreCuentasService.setBytteConfig(
        this.parametersService.getSetting(OpEnum.BYTTE_SDK_CONFIG),
      );
      if (this.channelId == CHANNEL.PORTALALLIES.CODE) {
        this.startFlow();
      } else {
        this.channelCommunicatorService
          .retreiveAndSetDeviceInfo()
          .then(async () => {
            if (this.isPostLogin && this.productPreselected) {
              this.configurationService.selectProduct(this.productPreselected);
              this.configurationService.getProductIsReady().pipe(takeUntil(this._subscriber$)).subscribe(
                (isReady: boolean) => {
                  if (isReady) {
                    this.startFlow();
                  }
                },
              );
            } else {
              this.startFlow();
            }
          });
      }
    } catch (err) {
      console.error(err);
    }
  }

  private async startFlow() {
    if (this.channelId !== CHANNEL.SUPERAPP.CODE || this.channelId == CHANNEL.PORTALALLIES.CODE) {
      await this.navigationService.startFlow(
        this.abreCuentasService.getPostlogin(),
      );
      this.tagReady = true;
      this.abreCuentasService.setAppLoaded(true);
    } else {
      this.channelCommunicatorService.retreiveAndSetAppInfo();
      this.callCyxteraBytte();
    }
  }

  private callCyxteraBytte() {
    this.abreCuentasService.setDsbMobileConfig(
      this.parametersService.getSetting(OpEnum.DSB_MOBILE_SDK_CONFIG),
    );
    this.dsbValidations();
    this.initBytte();
  }

  /* istanbul ignore next */
  /**
   * Validaciones dsb de seguridad de la aplicación en el dispositivo donde esta corriendo
   *
   * *dsb security valitation of the device where the app is running *
   *
   */
  private dsbValidations() {
    try {
      const license =
        this.abreCuentasService.getDsbMobileConfig().licenseKey[
        this.channelCommunicatorService.getChannelId()
        ];
      const secureUrl = this.abreCuentasService.getDsbMobileConfig().secureUrl;
      this.DSBinitCheck = true;
      this.DSBisSecureByRiskRules = true;
      this.DSBisSecureCertificate = true;
      this.checkDSBResult();

      // this.channelCommunicatorService
      //   .getImpl()
      //   .initDsbLicense(license)
      //   .then(response => {
      //     if (this.reconnectionAttempt(response)) {
      //       return;
      //     }
      //     if (this.rejectForSecurityCompliance(response)) {
      //       return;
      //     }
      //     this.DSBinitCheck = true;

      //     this.channelCommunicatorService
      //       .getImpl()
      //       .isSecureByRiskRules()
      //       .then(response1 => {
      //         if (this.rejectForSecurityCompliance(response1)) {
      //           return;
      //         }
      //         this.DSBisSecureByRiskRules = true;
      //         this.checkDSBResult();
      //       });

      //     this.channelCommunicatorService
      //       .getImpl()
      //       .isSecureCertificate(secureUrl)
      //       .then(response2 => {
      //         if (this.rejectForSecurityCompliance(response2)) {
      //           return;
      //         }
      //         this.DSBisSecureCertificate = true;
      //         this.checkDSBResult();
      //       });
      //   });
    } catch (error) {
      console.log(error);
    }
  }

  /* istanbul ignore next */
  /**
   * Validación de intentos de reconexión para el servicio de DSB
   *
   * *reconnection attempt validation for DSB service*
   *
   */
  private reconnectionAttempt(dsbResponse: ExternalResponse): boolean {
    if (dsbResponse.code === '2005') {
      this.dsbConnectionAttempts += 1;
      if (
        this.dsbConnectionAttempts <=
        this.abreCuentasService.getDsbMobileConfig().connectionMaxAttempts
      ) {
        this.dsbValidations();
        return true;
      }
      this.abreCuentasService.setDsbSecurityCheckException(dsbResponse.code);
      this.tagReady = true;
      this.navigationService.navigateToGeneralInformation('dsbException');
      return true;
    }
    return false;
  }

  /* istanbul ignore next */
  /**
   * Verifica el resultado de DSB en el caso que sea rechazado por una brecha de seguridad
   *
   * *Check DSB result in case it was rejected by a security compliance*
   *
   */
  private rejectForSecurityCompliance(dsbResponse: ExternalResponse): boolean {
    // Evaluates if the response code is a blocking one.
    for (const code of this.abreCuentasService.getDsbMobileConfig()
      .disalloweCodes) {
      if (
        dsbResponse.code === code &&
        !this.navigationService.isGeneralInformationStep
      ) {
        this.tagReady = true;
        this.abreCuentasService.setDsbSecurityCheckException(code);
        this.navigationService.navigateToGeneralInformation('dsbException');
        return true;
      }
    }

    // Process general exceptions.
    switch (dsbResponse.code) {
      case '404':
      case '9000':
        if (!this.navigationService.isGeneralInformationStep) {
          this.tagReady = true;
          this.navigationService.navigateToGeneralInformation('500');
        }
        return true;
    }
    return false;
  }

  /* istanbul ignore next */
  /**
   * Verifica el resultado de DSB(seguridad de la app en el dispositivo) para después crear el flujo de la aplicación
   *
   * *Check DSB (app device security) Result and after creates the flow of the app*
   *
   */
  private async checkDSBResult() {
    if (
      this.DSBinitCheck &&
      this.DSBisSecureByRiskRules &&
      this.DSBisSecureCertificate
    ) {
      await this.navigationService.startFlow(
        this.abreCuentasService.getPostlogin(),
      );
      this.tagReady = true;
      this.abreCuentasService.setAppLoaded(true);
      return true;
    }
    return false;
  }

  /* istanbul ignore next */
  /**
   * Inicializa la configuración Bytte para establecer los parámetros de escaneo de imagenes
   *
   * *Set up Bytte configuration to establish parameters to images scanning*
   *
   */
  private initBytte() {
    this.channelCommunicatorService.getImpl().cleanResidualFiles();
    const impl = this.channelCommunicatorService.getImpl();
    const url = impl.registerBytteLicense(
      this.abreCuentasService.getBytteConfig().licenses[this.channelId]
        .activationURL,
    );
    this.abreCuentasService.setRegisterBytteLicensePromise(url);
  }

  /**
   * Inicializa el estado de icono de cargando de la aplicación
   *
   * *Set Loading State*
   *
   */
  private setLoadingSubscribe() {
    this.loadingSubscription = this.loadingService.loadingState.subscribe(
      state => (this.showLoading = state),
    );
  }

  /**
   * Suscribción al observable del header
   *
   * Header observable description
   *
   */
  private setHeaderSubscribe() {
    this.headerSubscription = this.headerService.headerState.subscribe(
      (header: IHeader) => {
        this.header = header;
        if (this.headerComponent && this.header.show) {
          this.headerComponent.ngOnInit();
        }
        this.cdRef.detectChanges();
      },
    );
  }

  /**
   * Define la clase principal, donde establece el canal de comunicación para la aplicación
   *
   * *Sets main class, where establishes communication channel for the app*
   *
   */
  setMainClass() {
    const MAIN = 'main';
    this.mainClass = `${MAIN}-${this.channelCommunicatorService.getChannelStyle()}`;
  }

  /**
   * Establece la altura del header
   *
   * *Sets header height*
   */
  setMainHeight() {
    let height = this.header.show ? 3.5 : 0;
    height = height + (this.header.steps ? 2.8 : 0);
    return this.domSanitizer.bypassSecurityTrustStyle(
      `--main-height: ${height}rem; padding-bottom: 24px`,
    );
  }

  /**
   * Establece la altura del header
   *
   * *Sets header height*
   */
  showFooter(): boolean {
    return false;
  }
  /**
   * se carga los departamentos
   *
   * *Sets header height*
   */
  async getDistrict() {
    await this.requestService.districtBrances().then(response => {
      this.abreCuentasService.setDistricts(response.body);
    });
  }
}
